import { config } from '../apiConfig';

const InvoicePdf = async (parameters) => {
    document.location.href = `${config.url}/api/mvc/voucher/invoice/${parameters.reserveId}`;
}

export default InvoicePdf;